import React, {useEffect, useState} from "react"

function Legal() {

    return (
        <div id="legal">
            <h2>Terms of Service</h2>
            <h3>I. Acceptance of Terms</h3>
            <p>By using this app (LVL UP), you agree to the following  terms of service (TOS). If you disagree with any part of the
                TOS, you are not authorized to use LVL UP.</p>
            <h3>II. User Content</h3>
            <p>You are responsible for the content you create, share, or submit on LVL UP. By using LVL UP, you agree not to post or
                share any content that is illegal, abusive, offensive, defamatory, or violates the rights of others.</p>
            {/* <h3>III. Intellectual Property</h3>
            <p>LVL UP and its original content, features, and functionality are owned by LVL UP and are protected by international
                copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.</p> */}
            <h3>III. Privacy</h3>
            <p>Your privacy is important. Please review our Privacy Policy below to understand how your information is collected,
                used, and shared.</p>
            <h3>IV. Account Registration</h3>
            <p>You may need to create an account to access certain features of LVL UP. You are responsible for maintaining the
                confidentiality of your account information and are fully responsible for all activities that occur under your
                account.</p>
            <h3>V. Termination</h3>
            <p>We reserve the right to terminate, suspend, or limit your access to LVL UP at any time, without prior notice, for
                any reason, including violation of these TOS.</p>
            <h3>VI. Limitation of Liability</h3>
            <p>LVL UP and its affiliates, partners, and contributors shall not be liable for any indirect, incidental, special,
                consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other
                intangible losses.</p>
            <h3>VII. Terms Changes</h3>
            <p>These TOS may be revised at any time by updating this page. Your continued use of LVL UP after any changes to these
                terms constitutes acceptance of those changes.</p>
            {/* <h3>VIII. Governing Law</h3>
            <p>These TOS shall be governed and construed in accordance with the laws of [Your Jurisdiction], without regard to its
                conflict of law provisions.</p> */}

            <h2>Privacy Policy</h2>
            <h3>I. Information Collected</h3>
            <p>When you create a LVL UP account and use LVL UP, we may collect the following information:<br/>
                - Personal information such as username and email address.<br/>
                - Usage information such as the guides you create and your interactions with user content.</p>
            <h3>II. Information Usage</h3>
            <p>Collected information is used only to provide, maintain, and improve the functionality of LVL UP and user experience.
                Specifically, we may use your information for the following purposes:<br/>
                - Authenticating your identity for access to LVL UP features.<br/>
                - Communicating with you regarding your account and LVL UP updates.<br/>
                - Displaying your created guides and user profile.<br/>
                - Analytics to gauge and improve service quality.</p>
            <h3>III. Information Sharing</h3>
            <p>Personal information is not shared with third-parties, out of respect for your privacy, except in the
                following circumstances:<br/>
                - Your explicit consent for a specific purpose.<br/>
                - The request of service providers who assist in the operation of LVL UP.<br/>
                - If required to do so by law or in response to valid legal requests.<br/></p>
            <h3>IV. Security</h3>
            <p>We take data security seriously and implement measures to safeguard your information. However, no method of data
                transmission over the internet is completely secure. We cannot guarantee the security of your information.</p>
            <h3>V. User Choice</h3>
            <p>You can delete your shared content and guides by accessing them on your account page.</p>
            <h3>VI. Policy Changes</h3>
            <p>This Privacy Policy may be updated to reflect changes in our practices or legal requirements. You will be notified
                of any significant changes by posting the updated Privacy Policy on this page.</p>
            
            <h2>Contact</h2>
            <p id="contact">If you have any questions about the Terms of Service or Privacy Policy, please contact the developer at
                <a href="mailto:0xda032@gmail.com"> 0xda032@gmail.com</a>.</p>
        </div>
    )
}

export default Legal;